import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { trackPageView } from "@/lib/gtag";

/**
 * Returns true if the current environment is a Lovable preview or bot traffic
 * that should not be tracked.
 */
function shouldSkipTracking(): boolean {
  const hostname = window.location.hostname;
  if (hostname.includes("lovableproject.com") || hostname.includes("lovable.app")) {
    if (hostname.includes("id-preview--")) return true;
  }
  if (document.referrer.includes("__lovable_token")) return true;
  const ua = navigator.userAgent;
  if (/Chrome\/119\.0\.0\.0/.test(ua) && !/Mobile/.test(ua)) return true;
  return false;
}

/**
 * Lightweight page view tracker. Records every page visit to page_analytics
 * and sends a GA4 page_view event. Skips Lovable preview and bot traffic.
 */
export function usePageAnalytics(pagePath: string, pageTitle: string) {
  useEffect(() => {
    if (shouldSkipTracking()) return;

    // Internal analytics
    supabase.from("page_analytics").insert({
      page_path: pagePath,
      page_title: pageTitle,
      referrer: document.referrer || "",
      user_agent: navigator.userAgent || "",
    }).then(() => {});

    // Google Analytics 4
    trackPageView(pagePath, pageTitle);
  }, [pagePath, pageTitle]);
}

